export default __webpack_public_path__ + "static/media/logo02.e2a8b525.webp";